module.exports = __webpack_public_path__ + "static/img/match.c994be76.svg";